import { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { FAQ_CATEGORY_CONFIG } from '@/store/faq/config';

import { CategoryButton } from './CategoryControl.styles';
import { TCategoryControlProps } from './types';

const CategoryControl = ({
  category,
  isActive,
  isInoperable,
  tabIndex,
  testId,
  itemRef,
  onSelect,
}: TCategoryControlProps) => {
  const intl = useIntl();

  const handleClick = useCallback(() => {
    if (isInoperable) return;

    onSelect(category);
  }, [isInoperable, onSelect, category]);

  return (
    <CategoryButton
      type="button"
      ref={itemRef}
      tabIndex={tabIndex}
      data-testid={testId}
      $active={!!isActive}
      aria-pressed={isActive !== undefined ? isActive : undefined}
      aria-disabled={isInoperable}
      onClick={handleClick}
    >
      <span className={`rioglyph rioglyph-${category}`} aria-hidden="true" />
      {intl.formatMessage({ id: FAQ_CATEGORY_CONFIG[category].tooltipText })}
    </CategoryButton>
  );
};

export default memo(CategoryControl);
